/**
 * Публичный просмотр комплектовочной ведомости (E13 / E09, ФТ-11.3).
 * Только при активном допуске `bom`; цены позиций не отдаются (отдельный price preview).
 */

import { z } from "zod";
import { bomWeightSourceSchema } from "./bom";
import { decimalStringSchema } from "./catalog";
import { apiSuccessSchema } from "./envelope";

export const publicBomPreviewRequestSchema = z.object({
  projectId: z.string().uuid(),
  unitId: z.string().uuid(),
});
export type PublicBomPreviewRequest = z.infer<typeof publicBomPreviewRequestSchema>;

export const publicBomPreviewItemSchema = z.object({
  section: z.string().min(1),
  componentCode: z.string().nullable(),
  name: z.string().nullable(),
  qty: decimalStringSchema,
  unitWeightKg: decimalStringSchema.nullable(),
  totalWeightKg: decimalStringSchema.nullable(),
  weightSource: bomWeightSourceSchema.nullable(),
});
export type PublicBomPreviewItem = z.infer<typeof publicBomPreviewItemSchema>;

export const publicBomPreviewResultSchema = z.object({
  accessGranted: z.boolean(),
  accessHint: z.literal("request_required").nullable(),
  versionNo: z.number().int().positive().nullable(),
  totalWeightKg: decimalStringSchema.nullable(),
  items: z.array(publicBomPreviewItemSchema).nullable(),
});
export type PublicBomPreviewResult = z.infer<typeof publicBomPreviewResultSchema>;

export const publicBomPreviewResultResponseSchema = apiSuccessSchema(publicBomPreviewResultSchema);

export const PUBLIC_BOM_ERROR_CODES = {
  PROJECT_NOT_FOUND: "PUBLIC_BOM_PROJECT_NOT_FOUND",
  NO_CLIENT: "PUBLIC_BOM_NO_CLIENT",
  UNIT_NOT_FOUND: "PUBLIC_BOM_UNIT_NOT_FOUND",
  NO_PUBLISHED_BOM: "PUBLIC_BOM_NO_PUBLISHED_BOM",
} as const;
export type PublicBomErrorCode =
  (typeof PUBLIC_BOM_ERROR_CODES)[keyof typeof PUBLIC_BOM_ERROR_CODES];
